var map = {
	"./API.svg": 5150,
	"./Aliks.png": 5051,
	"./Amploo.png": 6649,
	"./Apix-Drive.svg": 8473,
	"./Bitrix24.svg": 2010,
	"./CleverBox.png": 7797,
	"./ConnectiveOne.svg": 9910,
	"./Creatio.svg": 7089,
	"./EasyBusy.png": 9928,
	"./G-plus.png": 6421,
	"./JediDesk.png": 1464,
	"./KeepinCRM.svg": 9516,
	"./Keruj.svg": 9790,
	"./KeyCRM.svg": 1869,
	"./KommoCRM.svg": 4435,
	"./LBS.png": 8208,
	"./NetHunt.svg": 2128,
	"./NextCRM.svg": 1331,
	"./NovaTalks.svg": 2989,
	"./Odoo.svg": 2489,
	"./OneBox.svg": 5113,
	"./Pager.svg": 7879,
	"./Perfectum.png": 2344,
	"./PlanFix.svg": 4576,
	"./Prodazhy.svg": 7293,
	"./ROapp.svg": 4552,
	"./SalesDrive.svg": 4210,
	"./SendPulse.svg": 1911,
	"./Sitniks.svg": 527,
	"./Skynum.png": 8488,
	"./TradeEVO.png": 8415,
	"./TrendCRM.png": 358,
	"./Uspacy.svg": 4631,
	"./VoipTime.svg": 4895,
	"./Wepster.png": 4561,
	"./X10CRM.png": 6236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6648;